import { render, staticRenderFns } from "./AttributeLevelsList.vue?vue&type=template&id=0a49fc70"
import script from "./AttributeLevelsList.vue?vue&type=script&lang=ts"
export * from "./AttributeLevelsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports